import { Alert } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectActiveGlobalDiscount } from '../../slices/activeGlobalDiscountSlice';
import { buildDiscountBannerGroups, discountsForCompany } from '../../utils/activeGlobalDiscount';

const bannerStyle = {
    backgroundColor: '#fff6f2',
    borderColor: '#f2d6cb',
    color: '#b5430f',
};

const withDiscountEmoji = (message) => `🎁 ${message}`;

const ActiveGlobalDiscountBanner = ({
    allowGuestPrompt = false,
    companyRuc = null,
    compact = false,
    prominent = false,
}) => {
    const userInfo = useSelector((state) => state.auth.userInfo);
    const activeGlobalDiscount = useSelector(selectActiveGlobalDiscount);
    const companiesByRuc = useSelector((state) => state.companies?.companiesByRuc || {});
    const alertClassName = prominent
        ? 'home-promo-banner border mb-0'
        : compact
            ? 'promo-notice border mb-2'
            : 'py-2 px-3 mb-3 border';

    if (!userInfo) {
        if (!allowGuestPrompt || companyRuc) {
            return null;
        }

        return (
            <Alert className={alertClassName} style={bannerStyle}>
                <Link
                    to="/register"
                    className={`fw-semibold${prominent ? ' home-promo-copy' : ''}`}
                    style={{ color: '#b5430f', textDecoration: 'none' }}
                >
                    {withDiscountEmoji('Regístrate y recibe un descuento en tu primera compra.')}
                </Link>
            </Alert>
        );
    }

    const resolveCompanyName = (ruc) => (
        companiesByRuc[ruc]?.tradeName || companiesByRuc[ruc]?.name || ruc
    );
    const groups = buildDiscountBannerGroups(
        discountsForCompany(activeGlobalDiscount, companyRuc || undefined),
        resolveCompanyName
    );

    if (groups.length === 0) {
        return null;
    }

    return (
        <Alert className={alertClassName} style={bannerStyle}>
            {groups.map((group) => (
                <div key={group.kind}>
                    {group.lines.map((line) => (
                        <div key={`${group.kind}-${line.key}`} className={prominent ? 'home-promo-row' : (compact ? '' : 'mb-1')}>
                            <span className={`fw-semibold${prominent ? ' home-promo-copy' : ''}`}>{withDiscountEmoji(line.message)}</span>
                            {line.minimumLabel ? (
                                prominent ? (
                                    <span className="home-promo-min">Mínimo {line.minimumLabel}.</span>
                                ) : (
                                    <small className="d-block">Mínimo {line.minimumLabel}.</small>
                                )
                            ) : null}
                        </div>
                    ))}
                </div>
            ))}
        </Alert>
    );
};

export default ActiveGlobalDiscountBanner;
